import PropTypes from 'prop-types';
import React from 'react';
import { Select } from '@weezevent/nacre';

export default function InventoryPicker({ currentInventory, inventories, disabled, onChange, allowEmpty = false, emptyPlaceholder = '' }) {
    const [selectedInventory, setSelectedInventory] = React.useState(currentInventory);

    const options = React.useMemo(() => {
        let values = Object.values(inventories)
            .filter(i => i)
            .map(inventory => ({
                text: inventory.name,
                value: inventory.uuid,
                inventory
            }))
            .sort((i1, i2) => {
                // Ordering alphabetically if same date
                if (i1.label < i2.label) {
                    return -1;
                }
                if (i1.label > i2.label) {
                    return 1;
                }
                return 0;
            });

        if (allowEmpty) {
            values.unshift({
                text: emptyPlaceholder,
                value: null,
                inventory: null
            });
        }

        return values;
    }, [inventories, allowEmpty, emptyPlaceholder]);

    const change = React.useCallback(
        value => {
            const inventory = value ? inventories.find(i => i.uuid === value) : null;
            setSelectedInventory(inventory);
            onChange(inventory);
        },
        [onChange]
    );

    return <Select clearable={allowEmpty} disabled={disabled} name="form-field-name" onChange={change} options={options} value={selectedInventory?.uuid || null} />;
}

InventoryPicker.defaultProps = {
    onChange: () => {},
    disabled: false
};

InventoryPicker.propTypes = {
    currentInventory: PropTypes.object.isRequired,
    inventories: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    allowEmpty: PropTypes.bool,
    emptyPlaceholder: PropTypes.string
};
